// extracted by mini-css-extract-plugin
module.exports = {"colorBg":"#06000f","colorLavender":"#ab8add","colorNeutral50":"#fcf8f9"};